import { render } from "./UserDetail.vue?vue&type=template&id=d9b2baaa&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"

import "./UserDetail.vue?vue&type=style&index=0&id=d9b2baaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b2baaa"]])

export default __exports__